<template>
  <BaseCard class="card-base space-y-4 rounded-2xl">
    <VacancyMetadata
      v-if="showTop"
      :vacancy="vacancy"
      special
    />
    <h2 class="text-xl font-medium">
      {{ vacancy.title }}
    </h2>
    <div
      v-if="showExcerpt"
      class="line-clamp-2"
    >
      {{ vacancy.excerpt }}
    </div>
    <VacancyMetadata :vacancy="vacancy" />
    <NuxtLink
      class="btn btn-sm btn-primary lg:btn-md"
      :to="{name: 'vacatures-slug', params: {slug: vacancy.slug}}"
    >
      Bekijk vacature
    </NuxtLink>
    <VacancyReviews
      v-if="showReviews"
      :reviews="vacancy.commissioner?.references"
      :slug="vacancy.commissioner?.slug"
    />
    <div
      v-if="showUsps && usps?.length"
      class="prose text-sm"
    >
      <ul>
        <li
          v-for="usp in usps"
          :key="usp"
        >
          {{ usp }}
        </li>
      </ul>
    </div>
  </BaseCard>
</template>

<script setup lang="ts">
import type {Vacancy} from '~/graphql/graphql';

const props = withDefaults(defineProps<{
  showReviews?: boolean;
  showUsps?: boolean;
  showTop?: boolean;
  showExcerpt?: boolean;
  vacancy: Vacancy;
}>(), {
  showReviews: true,
  showTop: true,
});

const usps = computed(() => JSON.parse(props.vacancy.usps));

</script>
